const About = {
    about: {
        title: "Sobre mí",
        description: "Soy Anthony Cazares. A la fecha (septiembre 2025), voy a media carrera de Filosofía, cursé también media carrera en Derecho y en Ciencias de la Comunicación, y concluí la de Terapia Física. Además, hice un diplomado en Enfoque Centrado en la Persona. Sin embargo, mi día a día está hecho de marketing digital y videos de bodas —la vida se mueve de formas misteriosas.\n\nEl bajo eléctrico es lo mío, y de vez en cuando me asomo a YouTube para compartir algo de lo que me apasiona.\n\nTengo gustos tan erráticos que mañana seguro decidiré aprender sobre Física Cuántica. A veces escribo, aunque es sumamente tentativo bocear ideas y dejar que la IA las ordene por mí.\n\nPero este espacio en particular será dedicado a la filosofía, que es, al menos en apariencia, tan errática como mi propia personalidad."
    },
    contact: {
        title: "Ponte en contacto.",
        description: "Todo el tiempo estoy buscando nuevas formas de colaborar. Usa el formulario de contacto, o puedes enviarme un correo a",
        email: "hola@anthonycazares.cafe",
        formspree: ""
    },
    home: {
        name: "Anthony Cazares",
        title: "Blog de Filosofía",
        description: "Detalles sobre conocimiento inútil",
    },
    social: {
        instagram: "anthonycazares_",
        youtube: "anthonycazares_",
        facebook: "AnthonyCazaresSanaryCrecer"
    },

};

export default About;
